export enum Formule {
  CONF = 'CON2', //Confort
  CONFPlus = 'CON+2', //Confort +
  LM = 'LM',
  PAR = 'PAR2',
  TOU = 'TOU2',
  LIL = 'LIL2',
  SOL = 'SOL2',
  GRE = 'GRE', // Grenoble
  CRE = 'CRE', // Créteil
  MAR = 'MAR', // Marseille
  ETU = 'ETU', // Etudiant
  BSOL = 'BSOL',
}

export enum NatureResidence {
  Principale = 'Principal',
  Secondaire = 'Secondary',
  ForRent = 'PourLocation',
  Etudiant = 'Etudiant',
  Chambre = 'PrivateRoomOutsideCrous', // Chambre chez particulier / Résidence hors CROUS
  ChambreCROUS = 'RoomInsideUniversity', // Chambre CROUS
  Inconnue = 'Unknown',
}

export enum TypeHabitation {
  Appartement = 'Apartment',
  Maison = 'House',
  Autres = 'Autres',
  Chambre = 'Room',
  Inconnu = 'Unknown',
}

export enum Lessor {
  Unknown,
  Prive = 'Private',
  Social = 'Social',
}

export enum LessorType {
  Arcade = 1,
  Contracted = 2, // Conventionné
  Altima = 3,
  AgreedUponMutualContent = 4, // Gré à gré
  NonContracted = 5, // Non conventionné
  Other = -1,
}

export enum SuperficieChambre {
  Unknown = 'Unknown',
  CROUSMoinsDe10m2 = 'CROUSMoinsDe10m2',
  MoinsDe10m2 = 'MoinsDe10m2',
  De11a40m2 = 'De11a40m2',
  PlusDe40m2 = 'PlusDe40m2',
}

export enum QualiteOccupant {
  Proprietaire = 'Owner',
  Locataire = 'Tenant',
  Colocataire = 'Roommate', // Utilisé ?
}

export enum Etage {
  RezDeChaussee = 'GroundFloor',
  Intermediaire = 'MiddleFloor',
  DernierEtage = 'TopFloor',
}

export enum SurfaceDependance {
  Aucune = 'None',
  De40a100m2 = '_40_100m2',
  PlusDe100m2 = '_100_250m2',
  PlusDe250m2 = '_250m2',
  MoinsDe40m2 = '_0_40m2',
  PlusDe40m2 = '_40m2', // Etudiante ?
  Inconnue = 'Unknown',
  Entre9m2Et40m2 = '_9_40m2',
  MoinsDe9m2 = '_9m2',
}

export enum TypePromo {
  Pourcentage = 'Pourcentage',
  MoisOfferts = 'MoisOfferts',
}

export enum TypeResilConcurrence {
  ChangeAssureur = 'ChangeAssureur',
  Emmenagement = 'Emmenagement',
}

export enum ValidityContractInsurance {
  LessThanOneYear = 'lessThanOneYear',
  MoreThanOneYear = 'moreThanOneYear',
}
